<template>
  <img :src="src" class="line-pay" alt="LINE Pay" />
</template>

<script setup lang="ts">
import src from '@/assets/logos/line-pay.png'
</script>

<style scoped>
.line-pay {
  display: block;
  height: 32px;
  width: auto;
  object-fit: contain;
}
</style>
